var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDocument = function SvgDocument(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    xmlSpace: "preserve",
    style: {
      enableBackground: "new 0 0 20 20"
    }
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 7h-6a.5.5 0 0 1-.5-.5v-6a.5.5 0 0 0-.5-.5H4a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7.5a.5.5 0 0 0-.5-.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 5H18l-5-5v4.5a.5.5 0 0 0 .5.5z"
  })));
};
export default SvgDocument;